import type { AlignFontType } from '@/lib/dashboard/dashboardCustomization/textOptions';
import {
    ALIGN_CENTER,
    ALIGN_LEFT,
    ALIGN_RIGHT
} from '@/lib/dashboard/dashboardCustomization/textOptions';
export const LAYOUT_COVER_NO_IMAGE_1 = 'layout_cover_no_image_1';
export const LAYOUT_COVER_NO_IMAGE_2 = 'layout_cover_no_image_2';
export const LAYOUT_COVER_IMAGE_CENTER = 'layout_cover_image_center';
export const LAYOUT_COVER_IMAGE_LEFT = 'layout_cover_image_left';
export const LAYOUT_END_PAGE_BOTTOM = 'layout_end_page_bottom';
export const LAYOUT_END_PAGE_BOTTOM_LEFT = 'layout_end_page_bottom_left';
export const LAYOUT_END_PAGE_CENTER = 'layout_end_page_center';
export const LAYOUT_END_PAGE_BOTTOM_RIGHT = 'layout_end_page_bottom_right';

export type LayoutFirstPageEntryType =
    | typeof LAYOUT_COVER_NO_IMAGE_1
    | typeof LAYOUT_COVER_NO_IMAGE_2
    | typeof LAYOUT_COVER_IMAGE_CENTER
    | typeof LAYOUT_COVER_IMAGE_LEFT;
type LayoutFirstPageType = Record<LayoutFirstPageEntryType, { id: LayoutFirstPageEntryType }>;

export const LAYOUTS: LayoutFirstPageType = {
    [LAYOUT_COVER_NO_IMAGE_1]: {
        id: LAYOUT_COVER_NO_IMAGE_1
    },
    [LAYOUT_COVER_NO_IMAGE_2]: {
        id: LAYOUT_COVER_NO_IMAGE_2
    },
    [LAYOUT_COVER_IMAGE_CENTER]: {
        id: LAYOUT_COVER_IMAGE_CENTER
    },
    [LAYOUT_COVER_IMAGE_LEFT]: {
        id: LAYOUT_COVER_IMAGE_LEFT
    }
};

export type LayoutEndPageEntryType =
    | typeof LAYOUT_END_PAGE_BOTTOM
    | typeof LAYOUT_END_PAGE_BOTTOM_LEFT
    | typeof LAYOUT_END_PAGE_CENTER
    | typeof LAYOUT_END_PAGE_BOTTOM_RIGHT;
type LayoutEndPageType = Record<LayoutEndPageEntryType, { id: LayoutEndPageEntryType }>;

export const LAYOUTS_END_PAGE: LayoutEndPageType = {
    [LAYOUT_END_PAGE_BOTTOM]: {
        id: LAYOUT_END_PAGE_BOTTOM
    },
    [LAYOUT_END_PAGE_BOTTOM_LEFT]: {
        id: LAYOUT_END_PAGE_BOTTOM_LEFT
    },
    [LAYOUT_END_PAGE_CENTER]: {
        id: LAYOUT_END_PAGE_CENTER
    },
    [LAYOUT_END_PAGE_BOTTOM_RIGHT]: {
        id: LAYOUT_END_PAGE_BOTTOM_RIGHT
    }
};

export function getTextAlign(
    layout: LayoutFirstPageEntryType | LayoutEndPageEntryType
): AlignFontType {
    switch (layout) {
        case LAYOUT_COVER_IMAGE_LEFT:
        case LAYOUT_END_PAGE_BOTTOM_LEFT:
            return ALIGN_LEFT;
        case LAYOUT_END_PAGE_BOTTOM_RIGHT:
            return ALIGN_RIGHT;
        default:
            return ALIGN_CENTER;
    }
}
